<template>
  <header-middle />
  <about-banner />
  <counter-template :areaFlag="areaFlag" />
  <!--  <grid-template /> -->
  <footer-template />
</template>

<script setup>
import { ref } from "vue";

import HeaderMiddle from '../section/header/header.vue'
import GridTemplate from "../section/footer/grids.vue";
import FooterTemplate from "../section/footer/footer.vue";
import AboutBanner from "../section/pages/About/about.vue"
import CounterTemplate from "../section/item/counter.vue";
let areaFlag = ref(false)
setInterval(getArea,1000)
function getArea(){
  if (window.innerWidth < 500 && window.scrollY >= 400) {
    areaFlag.value = true
	}else if (window.innerWidth > 500 && window.scrollY > 500) {
    areaFlag.value = true
	}
}
</script>

<style scoped>
*{
  text-align: justify;
}
</style>